import {IComponentController} from "angular";
import "../../../styles/email-settings-preview.scss";

export class EmailSettingsPreview implements IComponentController {
    public emailPreviewData: string;
    public isLoading: boolean;

    public static instance = {
        template: require('./email-settings-preview.html'),
        controller: EmailSettingsPreview,
        bindings: {
            emailPreviewData: '=',
            isLoading: '='
        }
    };
}
